import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import CartAccordion from "../../Components/Collops/CartAccordion";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./index.css";

import { cartOperations } from "../../state/ducs/cart";
import { numberWithCommas } from "../../utils";

const ViewPage = ({ cartItems, changeProductQuantity, isAuthenticated }) => {
  const navigate = useNavigate();

  let totalQuantity = 0;
  let subTotal = 0;
  for (let index = 0; index < cartItems.length; index++) {
    const element = cartItems[index];
    totalQuantity += parseInt(element.quantity);
    subTotal += element.quantity * element.price;
  }

  const onProductQuantityChange = (e, product) => {
    const quantity = e.target.value;
    if (quantity < 1) {
      return;
    }
    changeProductQuantity(product, quantity);
  };

  const onContinueShoppingHandler = () => {
    navigate("/");
  };

  const onCheckoutHandler = () => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    navigate("/checkout");
  };

  return (
    <div>
      <CartBannerComponent title="Shopping Cart" />
      <div className="container">
        <div className="row">
          <h1 className="cart-title">Shopping Cart ( {totalQuantity} unit(s) ) </h1>
          
          {/* Desktop Table View */}
          <div className="container d-none d-lg-block">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-center">Image</th>
                  <th>Product Name</th>
                  <th>Vendor Name</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length > 0 &&
                  cartItems.map((product, index) => (
                    <tr key={index}>
                      <td className="text-center">
                        <img
                          height={100}
                          width={100}
                          src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${product.photo}`}
                          alt={product.name}
                        />
                      </td>
                      <td>{product.name}</td>
                      <td>{product.vendor_name}</td>
                      <td>
                        <input
                          type="number"
                          value={product.quantity}
                          name="productQuantity"
                          className="quantity-input"
                          onChange={(e) => onProductQuantityChange(e, product)}
                        />
                      </td>
                      <td>৳{numberWithCommas(product.price)}</td>
                      <td>
                        ৳{numberWithCommas(product.price * product.quantity)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="container d-lg-none">
            {cartItems.length > 0 &&
              cartItems.map((product, index) => (
                <div key={index} className="cart-item-card">
                  <div className="cart-item-image">
                    <img
                      src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${product.photo}`}
                      alt={product.name}
                    />
                  </div>
                  <div className="cart-item-details">
                    <h5 className="product-name">{product.name}</h5>
                    <p className="vendor-name">{product.vendor_name}</p>
                    <div className="price-info">
                      <span className="label">Unit Price:</span>
                      <span className="value">৳{numberWithCommas(product.price)}</span>
                    </div>
                    <div className="quantity-section">
                      <label htmlFor={`qty-${index}`}>Quantity:</label>
                      <input
                        type="number"
                        id={`qty-${index}`}
                        value={product.quantity}
                        className="quantity-input-mobile"
                        onChange={(e) => onProductQuantityChange(e, product)}
                      />
                    </div>
                    <div className="total-price">
                      <span className="label">Total:</span>
                      <span className="value">৳{numberWithCommas(product.price * product.quantity)}</span>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <div className="container">
        <h1 className="section-title">What would you like to do next?</h1>
        <p className="section-description">
          Choose if you have a discount code or reward points you want to use or
          would like to estimate your delivery cost.
        </p>
        <div className="row">
          <CartAccordion cartItems={cartItems} subTotal={subTotal} />
        </div>
        <div className="row py-5 align-items-end cart-actions">
          <div className="col-md-6 col-12 mb-3 mb-md-0">
            <button
              onClick={onContinueShoppingHandler}
              type="button"
              className="btn btn-danger btn-block-mobile"
            >
              Continue Shopping
            </button>
          </div>
          <div className="col-md-2 d-none d-md-block"></div>
          <div className="col-md-4 col-12">
            <table className="table table-bordered summary-table">
              <tbody>
                <tr>
                  <td className="text-right">
                    <strong>Sub-Total:</strong>
                  </td>
                  <td className="text-right">৳{numberWithCommas(subTotal)}</td>
                </tr>
                <tr>
                  <td className="text-right">
                    <strong>Total:</strong>
                  </td>
                  <td className="text-right">৳{numberWithCommas(subTotal)}</td>
                </tr>
              </tbody>
            </table>
            <div className="buttonContainer">
              <button
                onClick={onCheckoutHandler}
                type="button"
                className="btn btn-secondary btn-block-mobile"
              >
                CHECKOUT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cart,
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = {
  changeProductQuantity: cartOperations.changeQuantity,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPage);